export enum Technology {
  ABAP = "ABAP",
  ABAP_UNIT = "ABAP Unit",
  ANDROID = "Android",
  ANDROID_STUDIO = "Android Studio",
  BALSAMIQ = "Balsamiq",
  BLUEPRINT_JS = "Blueprint JS",
  CHAI = "Chai",
  CSS = "CSS",
  CODE_REVIEWS = "Code Reviews",
  CONFLUENCE = "Confluence",
  DESIGN_PATTERNS = "Design Patterns",
  DOCKER = "Docker",
  DOCKER_DESKTOP = "Docker Desktop",
  DOCKER_HUB = "Docker Hub",
  ENTERPRISE_ARCHITECT = "Enterprise Architect",
  END_TO_END_TESTING = "End-to-End Testing",
  ESLINT = "ESLint",
  EXPRESS = "Express",
  FIGMA = "Figma",
  GENERICS = "Generics",
  GIT = "Git Version Control",
  GITHUB = "GitHub",
  GRADLE = "Gradle",
  HTML = "HTML",
  HEIDI_SQL = "Heidi SQL",
  ICF_SERVICE = "ICF-Service",
  IONIC = "Ionic",
  JAVA = "Java",
  JAVASCRIPT = "JavaScript",
  JENKINS = "Jenkins",
  JEST = "Jest",
  JIRA = "Jira",
  JUNIT = "JUnit",
  KEYCLOAK = "Keycloak",
  KOTLIN = "Kotlin",
  LEAN_UX = "Lean UX",
  LINUX = "Linux",
  MD = "Markdown",
  MARIA_DB = "Maria DB",
  MAVEN = "Maven",
  MENTORING = "Mentoring",
  MIRO = "Miro",
  MOCHA = "Mocha",
  MOCKK = "MockK",
  MUI = "MUI",
  MYSQL = "MySQL",
  NEXTJS = "Next.js",
  NODEJS = "Node.js",
  OAUTH2 = "OAuth 2.0",
  OPEN_SQL = "Open SQL",
  OOD = "Object-Oriented Design",
  PACKAGE_JSON_BUILD_SCRIPTS = "package.json build-scripts",
  POSTGRES = "PostgreSQL",
  PORTAINER = "Portainer",
  RASPBERRY_PI = "Raspberry Pi",
  REACT = "React",
  REDUX = "Redux",
  REQ_ENGINEERING = "Requirements Engineering",
  REST = "REST",
  SCRUM = "Scrum",
  SCRUM_MASTER = "Scrum Master",
  SCSS = "SCSS",
  SAP_GUI = "SAP GUI",
  SAP_DYNPRO = "SAP Dynpro",
  SEQUELIZE = "Sequelize",
  SOFTWARE_ARCHITECTURE = "Software Architecture",
  SPRING_BOOT = "Spring Boot",
  SQL = "SQL",
  TRELLO = "Trello",
  TEAMWORK = "Teamwork",
  TDD = "Test Driven Development",
  TYPESCRIPT = "TypeScript",
  UI_UX_DESIGN = "UI/UX Design",
  UX_AUDITING = "UX Auditing",
  UNIT_TESTING = "Unit Testing",
  USABILITY_TESTING = "Usability Testing",
  USER_STORIES = "User Stories",
  VS_CODE = "Visual Studio Code",
  WINDOWS = "Windows",
  XML = "XML",
}
